
export interface ICreateExternalRepositorySettings {
    repositoryURL: string;
    username: string;
    password: string;
    file: File;
}

export interface IParentAccountInfo {
    parentAccountUuid:string;
}

export interface IDistributeRepoConfiguration {
    targetDeviceNames?: string[];
    targetGroupNames?: string[];
}

export interface IUpdateExternalRepositorySettings extends Partial<ICreateExternalRepositorySettings> { }
export class ExternalRepositoryDto {
    constructor(private readonly _object: unknown) {
    }

    get repositoryURL(): string {
        return this._object['repositoryURL'] || '';
    }

    get username(): string {
        return this._object['username'] || '';
    }

    get password(): string {
        return this._object['password'] || '';
    }

    get gpgFileName(): string {
        return this._object['gpgFileName'] || '';
    }

    get gpgContent(): string {
        return this._object['gpgContent'] || '';
    }

    get isEmpty(): boolean {
        return !this.repositoryURL && !this.username && !this.password && !this.gpgFileName && !this.gpgContent;
    }

    get externalRepoAccountUuid(): string {
        return this._object['externalRepoAccountUuid'] || '';
    }
}
